import { styled } from '@mui/material/styles';

const BoxContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '40%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.common.white,
  borderRadius: '12px',
  marginTop: theme.spacing(2),
  padding: theme.spacing(4),
  [theme.breakpoints.down('xl')]: {
    width: '55%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '60%',
  },
  [theme.breakpoints.down('md')]: {
    width: '80%',
  },
  [theme.breakpoints.down('sm')]: {
    width: '90%',
  },
}));

const Title = styled('p')(({ theme }) => ({
  textAlign: 'center',
  fontSize: '22px',
  width: '90%',
  fontWeight: 700,
  paddingBottom: theme.spacing(1),
  fontStyle: 'italic',
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

const Description5Component = () => {
  return (
    <BoxContainer>
      <Title className="typography-v1-body1">
        Vi mener at det er viktig å sjekke om du kan få lavere rente. Det kan nemlig spille en stor
        rolle i din økonomi.
      </Title>
    </BoxContainer>
  );
};

export default Description5Component;
